module.exports = __webpack_public_path__ + "7412e31b5dcaaea2f8f6e6f33c80091f.svg";